import React, {memo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Switch, useHistory, useRouteMatch} from 'react-router-dom';
import Headline from 'components/Headline/styles';
import {DashboardContent} from 'components/DashboardContent/styles';
import {DashboardHeader} from 'components/DashboardHeader/styles';
import {ButtonPrimary} from 'components/buttons';
import {DashboardHeaderActions} from 'routes/App/orders/OrdersList/styles';
import {
  DiscountsTab,
  DiscountsTabsBar
} from 'routes/App/discountsV2/styles/DiscountsTabs';
import DiscountsList from 'routes/App/discountsV2/DiscountsList';
import RecommendedDiscounts from 'routes/App/discountsV2/RecommendedDiscounts';
import Modals from 'routes/App/discountsV2/DiscountsList/Modals';
import {PUSH_MODALS_STACK} from 'store/discountsV2/action';
import {DISCOUNT_MODALS_V2} from 'helpers/constants/discountsV2';
import {REPORT_TYPES} from 'helpers/constants/reports';
import MoreActionsMenu from 'components/MoreActionsMenu';

const DiscountsRoutesV2 = () => {
  const {path} = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();
  const isByocOnly = useSelector(
    (state) =>
      state.user.activeLocation?.IsByocOnly === true ||
      state.user.activeLocation?.isByocOnly === true
  );

  const addNewDiscount = () => {
    dispatch(PUSH_MODALS_STACK({type: DISCOUNT_MODALS_V2.SELECT}));
  };

  const handleExportSummaryReport = () => {
    history.push(`/reports?type=${REPORT_TYPES.DISCOUNT_SUMMARY}`);
  };

  const handleViewArchivedDiscounts = () => {
    history.push('/discounts-v2/your-discounts?status=Archived');
  };

  return (
    <DashboardContent className='DashboardContent'>
      <DashboardHeader className='AlwaysFlex'>
        <Headline className='mTop5'>Discounts</Headline>
        <DashboardHeaderActions className='DiscountActions'>
          <ButtonPrimary
            onClick={(e) => {
              e.stopPropagation();
              addNewDiscount();
            }}
            className='ButtonMedium solid'
            data-gtm='addNewDiscountButton'
          >
            <span data-gtm='addNewDiscountButton'>Create New</span>
          </ButtonPrimary>
          <MoreActionsMenu
            options={[
              {
                label: 'Export Summary Report',
                onClick: handleExportSummaryReport,
                hidden: isByocOnly
              },
              {
                label: 'View Archived Discounts',
                onClick: handleViewArchivedDiscounts
              }
            ]}
          />
        </DashboardHeaderActions>
      </DashboardHeader>
      <DiscountsTabsBar>
        <DiscountsTab
          activeClassName='isActive'
          to='/discounts-v2/recommended'
          isActive={(match, location) =>
            match !== null ||
            !location.pathname.startsWith('/discounts-v2/your-discounts')
          }
        >
          Recommended for You
        </DiscountsTab>
        <DiscountsTab
          activeClassName='isActive'
          to='/discounts-v2/your-discounts'
        >
          Your discounts
        </DiscountsTab>
      </DiscountsTabsBar>
      <Switch>
        <Route path={`${path}/your-discounts`} component={DiscountsList} />
        <Route
          exact
          path={[path, `${path}/recommended`]}
          component={RecommendedDiscounts}
        />
      </Switch>
      <Modals />
    </DashboardContent>
  );
};

export default memo(DiscountsRoutesV2);
